import { render, staticRenderFns } from "./sidebar-expansion.vue?vue&type=template&id=70436b24&scoped=true&"
import script from "./sidebar-expansion.vue?vue&type=script&lang=js&"
export * from "./sidebar-expansion.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-expansion.vue?vue&type=style&index=0&id=70436b24&lang=scss&scoped=true&"
import style1 from "./sidebar-expansion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70436b24",
  null
  
)

export default component.exports